import React, { useEffect, useState, useCallback } from "react";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { CloseIcon } from "../assets/Icons";
import apiClient from "../apiClient";
import { SSO_URL } from "../env";
import { GET_CHANNEL_WITH_DIRECTORY_LIST } from "../apiClient/apiEndpoints";

const selectTheme = (theme) => ({
  ...theme,
  borderRadius: 5,
  colors: {
    ...theme.colors,
    primary50: "#ca373c50",
    primary25: "#ca373c50",
    primary: "#ca373c70",
    danger: "#000000",
    neutral30: "#00000050",
  },
});

const AddDirectory = ({
  openModal,
  handleCloseModal,
  editMode = false,
  setDetails,
  saveNewDirectory,
  details,
}) => {
  const [channelsList, setChannelsList] = useState([]);
  const [directoryTypes, setDirectoryTypes] = useState([]);
  const [error, setError] = useState(null);

  const getChannelList = async () => {
    try {
      const data = await apiClient(`${SSO_URL}${GET_CHANNEL_WITH_DIRECTORY_LIST}`);
      setChannelsList(data.channels);
      setDirectoryTypes(data.types);
    } catch (err) {
      console.error(err);
    }
  };

  const hasError = useCallback((obj) => {
    return Object.values(obj).some((val) => !val?.trim?.());
  }, []);

  const handleSaveDetails = () => {
    setError(null);
    if (hasError(details)) {
      setError("Kindly fill all (*) fields.");
      return;
    }
    saveNewDirectory();
  };

  const handleInputChange = (key, value) => {
    setDetails((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    getChannelList();
  }, []);

  const directoryTypeOptions = directoryTypes.map((type) => ({ value: type, label: type }));
  const channelOptions = channelsList.map((ch) => ({ value: ch.uuid, label: ch.name }));

  const selectedType = directoryTypeOptions.find((opt) => opt.value === details?.type) || null;
  const selectedChannel = channelOptions.find((opt) => opt.value === details?.channelId) || null;

  return (
    <Modal show={openModal} size="md" centered onHide={() => handleCloseModal(false)}>
      <Modal.Header className="modalheader">
        {editMode ? "Edit Directory" : "Add New Directory"}
        <span onClick={() => handleCloseModal(false)}>
          <CloseIcon />
        </span>
      </Modal.Header>

      <Modal.Body className="pb-0">
        <div className="row">
          <div className="col-12 standardinput mt-1">
            <label className="mb-2">
              Name <span>*</span>
            </label>
            <input
              value={details.name}
              onChange={(e) => handleInputChange("name", e.target.value)}
              placeholder="Enter Directory Name"
              autoComplete="off"
              className="input form-control"
              type="text"
            />
          </div>

          <div className="col-12 standardinput mt-3">
            <label className="mb-2">
              Type <span>*</span>
            </label>
            <div className="forselect-input">
              <Select
                theme={selectTheme}
                value={selectedType}
                options={directoryTypeOptions.filter((opt) => opt.label !== "PRIMARY")}
                onChange={(opt) => handleInputChange("type", opt?.value)}
              />
            </div>
          </div>

          <div className="col-12 standardinput mt-3">
            <label className="mb-2">
              Default Channel
            </label>
            <div className="forselect-input">
              <Select
                theme={selectTheme}
                value={selectedChannel}
                options={channelOptions}
                isDisabled={editMode}
                onChange={(opt) => handleInputChange("channelId", opt?.value)}
              />
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="footerbtn mt-3">
        <button className="cancel" onClick={() => handleCloseModal(false)}>
          Cancel
        </button>

        <button className="save" onClick={handleSaveDetails}>
             {editMode ? "Update" : "Save"}
        </button>

        {error && <div className="w-100 text-end text-danger mt-2">{error}</div>}
      </Modal.Footer>
    </Modal>
  );
};

export default AddDirectory;
